<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Empty",
  created() {}
};
</script>
